const SwitchDraggableStyle = theme => ({
  switch: {

  },
})

export default SwitchDraggableStyle;